import { LinearGradient } from 'expo-linear-gradient'
import React, { useEffect, memo } from 'react'
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native'
import theme from '../../../../theme'
import styles from '../../stores/StoreDetailStyles'
import { StoreKPIIndicatorTheme } from '../../../../themeConstants'
import { AnimatedCircularProgress } from 'react-native-circular-progress'
import Constants from 'expo-constants'
import { getAlertColorFromRanges } from '../../../utils/functions.utils'
import Svg, { Path } from 'react-native-svg'

export const StoreKPIIndicators = React.memo(
    ({ item, index, onLayoutHeight }: any) => {
        const expoConfig = Constants.expoConfig || { slug: '' }
        const getGradientColors = (index) => {
            const gradientIndex = index % 5
            const isInverted = Math.floor(index / 5) % 2 === 1
            const gradientStartKey = `linearGradientStart0${gradientIndex}`
            const gradientEndKey = `linearGradientEnd0${gradientIndex}`

            // console.log(`Index: ${index}, Gradient Index: ${gradientIndex}, Is Inverted: ${isInverted}`)
            // console.log(`Start Color Key: ${gradientStartKey}, End Color Key: ${gradientEndKey}`)
            // console.log(`Start Color: ${theme.colors[gradientStartKey]}, End Color: ${theme.colors[gradientEndKey]}`)

            if (isInverted) {
                return [theme.colors[gradientEndKey], theme.colors[gradientStartKey]]
            } else {
                return [theme.colors[gradientStartKey], theme.colors[gradientEndKey]]
            }
        }
        //console.log('ITEM KPI ==>', item)
        const gradientColors = getGradientColors(index) as unknown as readonly [
            string,
            string,
        ]

        const renderItem = (type: string, value: number = 0) => {
            switch (type) {
                case 'last_relevamiento': {
                    const relevDate = item.relev_data?.date
                        ? new Date(item.relev_data.date)
                        : null
                    const isValidDate = relevDate && !isNaN(relevDate.getTime())
                    const dateLabel = isValidDate
                        ? `${String(relevDate.getDate()).padStart(2, '0')}/${String(
                              relevDate.getMonth() + 1,
                          ).padStart(2, '0')}`
                        : '-'
                    const relevName =
                        [item.relev_data?.name, item.relev_data?.last_name]
                            .filter(Boolean)
                            .join(' ') || '-'

                    return (
                        <View style={{}}>
                            <View
                                style={{
                                    justifyContent: 'center',
                                    height: 50,
                                    width: 75,
                                }}
                            >
                                <Text
                                    style={{
                                        fontSize: 28,
                                        fontWeight: '700',
                                        color: 'white',
                                    }}
                                    numberOfLines={1}
                                    adjustsFontSizeToFit
                                    minimumFontScale={0.6}
                                >
                                    {dateLabel}
                                </Text>
                            </View>
                            <Text
                                style={{
                                    fontSize: 12,
                                    color: 'white',
                                    fontWeight: '600',
                                    //textAlign: 'center',
                                    marginTop: 12,
                                }}
                                numberOfLines={2}
                                adjustsFontSizeToFit
                                minimumFontScale={0.6}
                            >
                                {relevName}
                            </Text>
                        </View>
                    )
                }
                case 'percentage':
                    const fix = 0 // value === 100 ? 0 : 1
                    const progressText =
                        value === -1 ? '-' : `${value.toFixed(fix)}%`

                    return (
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                            }}
                        >
                            {/* <Progress.Circle
                            size={70}
                            progress={value / 100}
                            showsText={false}
                            thickness={8}
                            color={StoreKPIIndicatorTheme.progressFilledColor}
                            unfilledColor={
                                StoreKPIIndicatorTheme.progressUnfilledCollor
                            }
                            borderWidth={0}
                            strokeCap='round'
                        /> */}
                            <AnimatedCircularProgress
                                size={70}
                                style={{ height: 50 }}
                                width={7}
                                fill={value}
                                tintColor={
                                    StoreKPIIndicatorTheme.progressFilledColor
                                }
                                backgroundColor={
                                    StoreKPIIndicatorTheme.progressUnfilledCollor
                                }
                                padding={0}
                                rotation={-90}
                                arcSweepAngle={180}
                                lineCap='round'
                            >
                                {() => (
                                    <Text
                                        style={{
                                            maxWidth: 70,
                                            fontSize: 13,
                                            fontWeight: 'bold',
                                            color: 'white',
                                            marginTop: -10,
                                        }}
                                        numberOfLines={1}
                                        adjustsFontSizeToFit
                                        minimumFontScale={0.5}
                                    >
                                        {progressText}
                                    </Text>
                                )}
                            </AnimatedCircularProgress>
                        </View>
                    )
                default: //"number"
                    return (
                        <View
                            style={{
                                width: 75,
                                height: 50,
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: 50,
                                    color: 'white',
                                    fontWeight: '700',
                                    textAlign: 'center',
                                }}
                                numberOfLines={1}
                                adjustsFontSizeToFit
                                minimumFontScale={0.7}
                            >
                                {value}
                            </Text>
                        </View>
                    )
            }
        }

        const setChangeColor = (value) => {
            if (
                !value ||
                value === '0' ||
                value === '0%' ||
                value === '' ||
                value === '-'
            ) {
                return 'white'
            }
            if (typeof value === 'string') {
                if (value.trim().startsWith('+')) {
                    return '#8fe98f'
                }
                if (value.trim().startsWith('-')) {
                    return '#e00000'
                }
            }
            return 'green'
        }

        const showLR =
            (item.monthOverMonthPercentChange &&
                item.monthOverMonthPercentChange != '') ||
            expoConfig.slug === 'savencia-one'
        // console.log('ITEM ==>', item)

        const alertRangeColor = getAlertColorFromRanges(
            item?.alerts,
            item?.scoreForm,
        )
        const isHighAlert = alertRangeColor === theme.colors.colorApproved

        const showAlert = {
            show: Boolean(alertRangeColor),
            color: alertRangeColor,
            text: isHighAlert ? 'ALTO' : 'ALERTA',
        }

        return (
            <View style={[styles.containerItemsIndicators]}>
                <TouchableOpacity
                    activeOpacity={1}
                    onPress={() => {
                        // console.log('ITEM KPI ==>', item)
                    }}
                >
                    <LinearGradient
                        style={[
                            {
                                width: 120,
                                borderRadius: 20,
                                padding: 12,
                                marginLeft: 8,
                            },
                        ]}
                        onLayout={(e) => {
                            onLayoutHeight?.(item._id, e.nativeEvent.layout.height)
                        }}
                        colors={gradientColors}
                        start={{ x: 0, y: 0 }}
                        end={{ x: 1, y: 0.5 }}
                    >
                        <View
                            style={{
                                justifyContent: 'center',
                                alignItems: 'center',
                                marginTop: 5,
                                height: 27,
                            }}
                        >
                            <Text
                                style={{
                                    fontSize: 11,
                                    fontWeight: 'bold',
                                    textTransform: 'uppercase',
                                    textAlign:
                                        item?.type === 'last_relevamiento'
                                            ? 'left'
                                            : 'center',
                                    color: 'white',
                                }}
                                numberOfLines={2}
                            >
                                {item.kpi}
                            </Text>
                        </View>
                        <View
                            style={[
                                styles.containerProgress,
                                { height: undefined, marginTop: 24 },
                            ]}
                        >
                            {renderItem(item.type, item.value)}
                        </View>
                        {item?.criticalMomentCode && (
                            <Text
                                style={[
                                    {
                                        fontSize: 11,
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        textAlign: 'center',
                                        color: 'white',
                                        marginTop: 5,
                                    },
                                ]}
                                numberOfLines={1}
                            >
                                {item.criticalMomentCode}
                            </Text>
                        )}
                        {!showAlert.show && showLR && (
                            <Text
                                style={{
                                    fontSize: 11,
                                    color: 'white',
                                    marginBottom: 0,
                                    marginTop: 2,
                                    textAlign: 'center',
                                }}
                            >
                                {'Variación LR'}
                                {'\n'}
                                <Text
                                    style={{
                                        color: setChangeColor(
                                            item?.monthOverMonthPercentChange,
                                        ),
                                        fontWeight: '700',
                                        fontSize: 13,
                                    }}
                                    numberOfLines={1}
                                >
                                    {item?.monthOverMonthPercentChange || '-'}
                                </Text>
                            </Text>
                        )}
                        {showAlert.show && (
                            <View
                                style={{
                                    alignSelf: 'center',
                                    width: 88,
                                    marginTop: 20,
                                    flexDirection: 'row',
                                    paddingHorizontal: 4,
                                    gap: 4,
                                    paddingVertical: 2,
                                    justifyContent: 'center',
                                    alignContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: 20,
                                    backgroundColor: showAlert.color,
                                }}
                            >
                                <Text
                                    style={{
                                        color: 'white',
                                        fontSize: 11,
                                    }}
                                >
                                    {showAlert.text}
                                </Text>
                                <View
                                    style={[
                                        { opacity: isHighAlert ? 0 : 1 },
                                        isHighAlert && { width: 0 },
                                    ]}
                                >
                                    <TwoToneWarningIcon
                                        size={16}
                                        triangleColor='#ffffff'
                                        markColor={showAlert.color}
                                    />
                                </View>
                            </View>
                        )}
                    </LinearGradient>
                </TouchableOpacity>
            </View>
        )
    },
)

// Phosphor's "fill" Warning icon renders the "!" as a cutout of the same
// color as the triangle (single Path, opposite winding), so it can't be
// recolored via the icon's `color` prop. This splits it into two Paths so
// the triangle and the "!" can each take their own color.
export const TwoToneWarningIcon = ({
    size = 30,
    triangleColor,
    markColor = '#ffffff',
}: {
    size?: number
    triangleColor: string
    markColor?: string
}) => (
    <Svg width={size} height={size} viewBox='0 0 256 256'>
        <Path
            fill={triangleColor}
            d='M236.8 188.09 149.35 36.22a24.76 24.76 0 0 0-42.7 0L19.2 188.09a23.51 23.51 0 0 0 0 23.72A24.35 24.35 0 0 0 40.55 224h174.9a24.35 24.35 0 0 0 21.33-12.19 23.51 23.51 0 0 0 .02-23.72Z'
        />
        <Path
            fill={markColor}
            d='M120 104a8 8 0 0 1 16 0v40a8 8 0 0 1-16 0Zm8 88a12 12 0 1 1 12-12 12 12 0 0 1-12 12'
        />
    </Svg>
)
